import { render, staticRenderFns } from "./arrivals_yearv2.vue?vue&type=template&id=b4892586&scoped=true"
import script from "./arrivals_yearv2.vue?vue&type=script&lang=js"
export * from "./arrivals_yearv2.vue?vue&type=script&lang=js"
import style0 from "./arrivals_yearv2.vue?vue&type=style&index=0&id=b4892586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4892586",
  null
  
)

export default component.exports